const PREDICT_ROUTE_NAMES = {
    home: 'AdoptionAgent',
    settings: 'AdoptionAgentSettings',
};

export function predictRouteName (page) {
    return PREDICT_ROUTE_NAMES[page];
}